import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IDealFilterOptions } from '../types';

export const getDealsFilterOptions = async ({ orgId }: { orgId: string }): Promise<IDealFilterOptions> => {
    const response = await axiosInstance.get<IDealFilterOptions>(API_ENDPOINTS.DEALS_FILTER_OPTIONS(orgId));
    return response.data;
};

export const useGetDealsFilterOptions = (orgId: string) => useQuery<IDealFilterOptions>({
    queryKey: ['dealsFilterOptions', orgId],
    queryFn: async () => getDealsFilterOptions({ orgId }),
    enabled: !!orgId,
});
